import { GameFlow } from './game/GameFlow';

const canvas = document.getElementById('game-canvas') as HTMLCanvasElement;
const flow = new GameFlow(canvas);

const tick = () => {
  requestAnimationFrame(tick);
  flow.update();
};
requestAnimationFrame(tick);
